import PropTypes from "prop-types";

export default PropTypes.shape({
  symbol: PropTypes.string,
  isoCode: PropTypes.string,
});
